import { Box, CircularProgress } from "@mui/material";
import React from "react";

const CircularLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        height: "30vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress style={{ color: "#0A84C1" }} />
    </Box>
  );
};

export default CircularLoader;
